import http from "../general/HttpClient";

export interface ReceivedMark {
  id: string;
  studentID: string;
  assessmentID: string;
  assessmentName: string;
  subjectName: string;
  academicYearName: string;
  cycleName: string;
  markTypeName: string;
  result: number;
  total: number;
  sourceClientID: string;
  revision: number;
  isLatestRevision: boolean;
  acceptedAt: string;
  calculationStatus: "Complete" | "Pending" | "NeedsAttention";
}

export interface ImportHistoryPage {
  items: ReceivedMark[];
  nextCursor: string | null;
}

export interface ImportDetail {
  import: ReceivedMark;
  requestID: string;
  sourceRecordID: string;
  sourceVersion: string;
  mappingVersion: string;
  studentModuleEnrollmentID: string;
  authenticatedSubjectID: string | null;
  sourceActorReference: string | null;
  evidenceReference: string | null;
  calculationFindings: Array<{
    code: string;
    severity: string;
    message: string;
  }>;
}

export interface HistoryFilters {
  search: string;
  calculationStatus: string;
  includeEarlierRevisions: boolean;
  cursor: string | null;
}

const base = "/api/assessment/mark-imports/history";

export async function listImportHistory(
  filters: HistoryFilters,
): Promise<ImportHistoryPage> {
  return (await http.get(base, { params: { ...filters, take: 25 } })).data;
}

export async function getImportDetail(id: string): Promise<ImportDetail> {
  return (await http.get(`${base}/${encodeURIComponent(id)}`)).data;
}
